import * as React from 'react';
import CharmControlColorProps from './CharmControlColorProps';
import { changeSvgColor, updateSvgFormat } from '../utils/CharmControlUtils';
import { getCharmForId } from 'owa-calendar-charms-store';
import { lazyLoadCharmSvgTextInMap } from 'owa-calendar-charms-store';
import { observer } from 'mobx-react';

export interface CharmControlProps {
    iconId: number;
    className?: string;
    colorProps?: CharmControlColorProps;
}

@observer
export default class CharmControl extends React.Component<CharmControlProps, any> {
    componentDidMount() {
        lazyLoadCharmSvgTextInMap.importAndExecute(this.props.iconId);
    }

    componentDidUpdate() {
        lazyLoadCharmSvgTextInMap.importAndExecute(this.props.iconId);
    }

    /*
     * <SVG> can't have its DOM elements modified when it comes from a CORS origin.
     * Because of this, we need to create a request, fetch the object as a string,
     * we apply some processing to it to set the appropiate charm color.
     * Then we insert it using dangerouslySetInnerHTML.
     */
    render() {
        return (
            /* tslint:disable:react-no-dangerous-html */
            <div
                className={this.props.className}
                id={'CharmControlID' + this.props.iconId}
                dangerouslySetInnerHTML={this.prepareSvgForInnerHtmlInsertion()}
            />
            /* tslint:enable:react-no-dangerous-html */
        );
    }

    /**
     * dangerouslySetInnerHTML needs that the code to be inserted is preceded by '__html:'
     */
    private prepareSvgForInnerHtmlInsertion = () => {
        let text = this.processSvgTag();
        return { __html: text };
    };

    /**
     * This function sets the SVG size, color and updates the CharmControl's state.
     */
    private processSvgTag = () => {
        let text = getCharmForId(this.props.iconId).SvgHtmlText;

        text = updateSvgFormat(text);
        text = changeSvgColor(this.props.iconId, text, this.props.colorProps);
        return text;
    };
}
